import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ReactSVG } from "react-svg";
import { useIntl } from 'react-intl';
import messages from '../messages';

import { useTheme } from '@mui/material/styles';
import { Box, Button, Typography, Modal, IconButton, CircularProgress, Stack, Breadcrumbs, Link } from '@mui/material';
import { IconSvg } from '../../../../utils/globalIcons';
import moment from 'moment';
import { getStyles } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { setExtractionDocumentTypesState, setExtractionFilesState } from '../../../../Redux/slice/dataSlice';
import ExtractionFilesData from '../../../../utils/ApiFunctions/ExtractionFilesData';
import LoadBar from '../../../../utils/LoadBar';
import { getMainStyles } from '../../../../styles/styles';
import { Close, CloudUpload, NavigateNextRounded, RefreshOutlined } from '@mui/icons-material';
import { extractionFileSave, getAllExtractionDocumentTypes } from '../../../../utils/ApiFunctions/ExtractionData';
import { tostAlert } from '../../../../utils/AlertToast';
import { useAppContext } from '../../../../context/AppContext';
import PaginationTable from '../../../../components/PaginationTable';
import { breadCrumbsStyles } from '../../../../styles/breadCrumbs';
import { useCheckCredit } from '../../../../utils';
import ExtractionTraining from '../../../../components/ExtractionTraining';
import handleFileUpload from '../../../../utils/fileUpload';

function DocumentLists() {
    const theme = useTheme();
    const styles = getStyles(theme);
    const mainStyles = getMainStyles(theme);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation()
    const { doc_type_id } = useParams();
    const { selectedProject } = useAppContext();
    const isOutOfCredits = useCheckCredit();
    const intl = useIntl();

    const [loading, setLoading] = useState(false);
    const [fileLoading, setFileLoading] = useState(false);

    const [filesData, setFilesData] = useState([]);
    const [lastKey, setLastKey] = useState(null);
    const [hasMore, setHasMore] = useState(true);

    const [selectedFiles, setSelectedFiles] = useState([]);
    const [documentTypes, setDocumentTypes] = useState([]);
    const documentTypeName = location?.state?.doc_type_name ?? null;
    const documentType = location?.state?.doc_type ?? null;
    const [previewMode, setPreviewMode] = useState("document");
    const [fileId, setFileId] = useState(null);

    const modalDetails = { modalstatus: false, document_name: null, document_id: '', document_type_name: '' };
    const [modalData, setModalData] = useState(modalDetails);

    const extraction_files = useSelector(state => state.all_data.extraction_files)
    const extraction_document_types = useSelector(state => state.all_data.extraction_document_types);

    useEffect(() => {
        getAllData()
        //eslint-disable-next-line
    }, [])

    const getAllData = async () => {
        setLoading(true)
        try {
            await Promise.all([
                getDocumentTypes(false),
                getAllExtractionFiles(false)]
            );
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }


    const getAllExtractionFiles = async (new_file) => {
        try {
            setFileLoading(true)
            const project_id = selectedProject?.payload?.__auto_id__ ?? null

            if ((extraction_files || [])?.length > 0 && new_file === false) {
                const filtered_files = (extraction_files || [])?.filter(item => item?.payload?.document_type === doc_type_id) ?? [];
                setFilesData(filtered_files);
                return filtered_files
            } else {
                let allData = [];
                let currentKey = lastKey;

                while (true) {
                    const response = await ExtractionFilesData(currentKey, project_id);
                    const responseData = response?.data ?? [];
                    const lastEvaluatedKey = response?.lastEvaluatedKey ?? null;

                    if (responseData.length > 0) {
                        allData = [...allData, ...responseData];
                        dispatch(setExtractionFilesState(responseData));
                        const filterd_files = (responseData || [])?.filter(item => item?.payload?.document_type === doc_type_id) ?? [];
                        setFilesData(filterd_files);
                        setLastKey(lastEvaluatedKey);
                        setHasMore(!!lastEvaluatedKey);
                        return filterd_files;
                    } else if (lastEvaluatedKey) {
                        currentKey = lastEvaluatedKey;
                        continue;
                    } else {
                        setHasMore(false);
                        return [];
                    }
                }
            }
        } catch (error) {
            console.log(error);
            return [];
        } finally {
            setFileLoading(false)
        }
    };

    const getDocumentTypes = async (is_added) => {
        try {
            let doc_type = []
            if (extraction_document_types?.length > 0 && is_added === false) {
                doc_type = extraction_document_types
            } else {
                const project_id = selectedProject?.payload?.__auto_id__
                const response = await getAllExtractionDocumentTypes(project_id);
                dispatch(setExtractionDocumentTypesState(response))
                doc_type = response
            }
            setDocumentTypes(doc_type)
            return doc_type;
        } catch (error) {
            console.log(error);
            return [];
        }
    }

    const onFetchNextPage = async () => {
        if (hasMore) {
            setLoading(true);
            try {
                const project_id = selectedProject?.payload?.__auto_id__ ?? null
                const { data, lastEvaluatedKey } = await ExtractionFilesData(lastKey, project_id);
                dispatch(setExtractionFilesState(prev => [...prev, ...data]))

                const filtered_files = data?.filter(item => item?.payload?.document_type === doc_type_id) ?? [];
                setFilesData(prev => [...prev, ...filtered_files]);
                setLastKey(lastEvaluatedKey);
                if (!lastEvaluatedKey) setHasMore(false);

            } finally {
                setLoading(false);
            }
        }
    };


    const handleModalOpen = async () => {

        if (isOutOfCredits) {
            tostAlert('Your credits have run out. Please top up account to continue.', 'error')
            return
        }

        const document_type = documentTypes?.find(item => item?.payload?.__auto_id__ === doc_type_id)?.payload ?? null;
        if (!document_type) {
            tostAlert(intl.formatMessage(messages.invalid_doctype), 'warning');
            return;
        }
        setModalData({ ...modalData, modalstatus: true, document_id: document_type?.__auto_id__, document_name: document_type?.name });
    }

    const handleModalClose = () => {
        setModalData(modalDetails);
    }

    const handleFileDrop = async (event) => {
        try {
            event.preventDefault();
            event.stopPropagation();
            const files = Array.from(event.dataTransfer.files);
            event.target.value = null;
            setSelectedFiles(files);
        } catch (error) {
            console.log(error)
        }
    };

    const handleFileChange = async (event) => {
        try {
            event.preventDefault();
            event.stopPropagation();
            const files = Array.from(event.target.files);
            event.target.value = null;
            setSelectedFiles(files);
        } catch (error) {
            console.log(error)
        }
    };

    const handleFileRemove = (index) => {
        const updatedFiles = [...selectedFiles];
        updatedFiles.splice(index, 1);
        setSelectedFiles(updatedFiles);
    }

    const handleUploadTrain = async () => {
        setLoading(true);
        try {
            if (selectedFiles?.length === 0) {
                tostAlert(intl.formatMessage(messages.file_selection_error), 'warning')
                return
            }

            const file_name = selectedFiles[0]?.name ?? "file";
            const upload_response = await handleFileUpload(file_name, selectedFiles[0])
            if (upload_response.status === 200) {
                const save_response = await extractionFileSave(upload_response.fileName, upload_response.fileUrl, upload_response.fileId, doc_type_id);
                if (save_response.status === 200) {
                    if (save_response.status === 200) {
                        const fileResponseData = save_response?.data?.id ?? null;
                        setModalData(modalDetails)
                        setFileId(fileResponseData)
                        setSelectedFiles([])
                        setPreviewMode("train")
                        setLastKey(null)
                        setHasMore(true)
                        getAllExtractionFiles(true)
                    }
                }
            }

        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    }

    const columns = [
        {
            id: 'payload.file_name',
            label: 'Name',
            sortable: true,
            renderCell: (row) => row?.payload?.file_name
        },
        {
            id: 'payload.uploaded_via',
            label: 'Uploaded via',
            sortable: true,
            renderCell: (row) => row?.payload?.uploaded_via
        },
        {
            id: 'payload.uploaded_on',
            label: 'Date added',
            sortable: true,
            renderCell: (row) => {
                const dateStr = row?.payload?.uploaded_on;
                const cleanStr = dateStr?.substring(0, 16);
                return moment(cleanStr, 'YYYY-MM-DD HH:mm').format('DD-MMM-YYYY hh:mm A');
            }
        }
    ];

    const breadcrumbs = [
        <Link underline="hover" key="1" color="inherit"
            onClick={() => navigate('/document-types')}
            sx={breadCrumbsStyles.linkHeader}>
            <Typography sx={styles.linkText}>All Documents</Typography>
        </Link>,
        <Typography key="1" sx={styles.mainHeadingText}>
            {documentTypeName}
        </Typography>,
    ];

    return (
        <Box sx={styles.mainContainer}>

            {(previewMode === "train" && doc_type_id && documentType && fileId) ?
                (<ExtractionTraining
                    document_type_id={doc_type_id}
                    document_type={documentType}
                    file_id={fileId}
                    setPreviewMode={setPreviewMode}
                />)
                :
                (<Box sx={styles.cardContainer}>

                    {(loading) && (<LoadBar />)}

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                        <Stack spacing={2} sx={{ marginLeft: '0' }}>
                            <Breadcrumbs
                                separator={<NavigateNextRounded fontSize="small" />}
                                aria-label="breadcrumb"
                            >
                                {breadcrumbs}
                            </Breadcrumbs>
                        </Stack>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Button
                                onClick={() => navigate('/document-types')}
                                sx={{ backgroundColor: '#DEDEDE', borderRadius: '20px', width: '100px' }}>
                                <Typography sx={{ fontSize: '14px', fontWeight: '600', color: '#000000' }}>
                                    CANCEL
                                </Typography>
                            </Button>
                            <Button
                                onClick={handleModalOpen}
                                sx={{ backgroundColor: '#0B51C5', borderRadius: '20px', width: '90px' }}>
                                <Typography sx={{ fontSize: '14px', fontWeight: '600', color: '#FFFFFF' }}>
                                    UPLOAD
                                </Typography>
                            </Button>
                        </Box>
                    </Box>

                    <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', marginTop: '20px' }}>
                        {fileLoading
                            ?
                            (<CircularProgress size={'20px'} />)
                            :
                            (<IconButton
                                onClick={() => getAllExtractionFiles(true)}
                            >
                                <RefreshOutlined />
                            </IconButton>
                            )}
                    </Box>

                    <Box marginTop={'10px'} paddingBottom={'20px'}>
                        <PaginationTable
                            data={filesData}
                            columns={columns}
                            loading={loading}
                            onFetchNextPage={onFetchNextPage}
                            hasMore={hasMore}
                        />
                    </Box>

                    <Modal open={modalData.modalstatus} onClose={handleModalClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                        <Box sx={mainStyles.modalcontainer}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography sx={{ fontSize: '16px', fontWeight: '600' }}>Upload File and Train</Typography>
                                <IconButton onClick={handleModalClose}>
                                    <Close />
                                </IconButton>
                            </Box>
                            <Box marginTop={'15px'}>
                                <Typography sx={{ fontSize: '14px', fontWeight: '600' }}>Document Type</Typography>
                                <Box sx={{
                                    display: 'flex', alignItems: 'center', borderRadius: '10px',
                                    backgroundColor: '#F3F5F7', padding: '12px', marginTop: '10px'
                                }}>
                                    <Typography sx={{ fontSize: '14px', fontWeight: '500', marginRight: '10px' }}>{modalData.document_name}</Typography>
                                    <ReactSVG
                                        src={IconSvg.resultCorrectIcon}
                                        beforeInjection={(svg) => {
                                            svg.setAttribute('style', 'width: 18px; height:18px; display: block;');
                                            svg.setAttribute('stroke', '#0B51C5');
                                        }}
                                    />
                                </Box>
                            </Box>
                            <Box sx={{
                                marginTop: '20px',
                                padding: '20px',
                                textAlign: 'center',
                                cursor: 'pointer',
                                backgroundColor: '#F3F5F7',
                                borderRadius: '20px',
                            }}>
                                <Box
                                    onDrop={handleFileDrop}
                                    onDragOver={(e) => e.preventDefault()}
                                >
                                    <input
                                        type="file"
                                        accept=".pdf,.docx,.xlsx,.png,.jpg,.jpeg"
                                        onChange={handleFileChange}
                                        style={{ display: 'none', cursor: 'pointer' }}
                                        id="fileInput"
                                    />
                                    <label
                                        id='fileInput'
                                        htmlFor="fileInput">
                                        {selectedFiles.length === 0 &&
                                            <Box>
                                                <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>Drag and drop files or&nbsp;<span style={{ color: '#0B51C5', cursor: 'pointer' }}>click to upload</span> </Typography>
                                                <Typography sx={styles.paraText}>
                                                    <p><strong>Accepted file formats:</strong> PDF, Word, Excel, PNG, JPG, JPEG</p>
                                                </Typography>
                                            </Box>
                                        }
                                        <IconButton component="span">
                                            <CloudUpload style={{ color: "black", width: "32px", height: "32px" }} />
                                        </IconButton>
                                    </label>
                                </Box>
                                <Box display={'flex'} justifyContent={'center'} alignItems={'center'} flexWrap="wrap" >
                                    {
                                        selectedFiles.length > 0 && selectedFiles.map((file, index) => (
                                            < Box key={index} display={'flex'} justifyContent={'center'} alignItems={'center'} alignContent={'center'} textAlign={'center'} padding={'3px 15px 3px 15px'} margin={'5px'} backgroundColor={'#FFFFFF'} borderRadius={'20px'}>
                                                <Typography sx={styles.paraText}>{file.name}</Typography>
                                                <Box marginLeft={'10px'} onClick={() => handleFileRemove(index)}>
                                                    <ReactSVG src={IconSvg.deleteIcon} className='delete_icon' />
                                                </Box>
                                            </Box>
                                        ))
                                    }
                                </Box>
                            </Box>
                            <Box sx={{ marginTop: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Button
                                    onClick={handleUploadTrain}
                                    disabled={loading}
                                    sx={styles.uploadBtn}>
                                    <Typography sx={styles.btnText}>Upload and Train</Typography>
                                </Button>
                            </Box>
                        </Box>
                    </Modal>

                </Box>)
            }
        </Box >
    )
}

export default DocumentLists